'use strict';

var ProfileChartToolbarController = function ProfileChartToolbarController($scope, $rootScope, constants) {
  function getBackButtonLabel(screenMode) {
    switch (screenMode) {
      case constants.FLIGHT_ANALYSIS_MODE:
        return 'FLIGHT ANALYSIS';
      case constants.FLIGHT_MANAGEMENT_MODE:
        return 'FLIGHT MGMT';
      default:
        return '';
    }
  }
  $scope.backButtonLabel = getBackButtonLabel($scope.contextData.screenMode);
  $scope.back = function () {
    $rootScope.$broadcast('profile-chart-panel:swap', false, {
      chartData: {},
      primaryEntity: {},
      referenceEntities: []
    });
  };
};
ProfileChartToolbarController.$inject = ['$scope', '$rootScope', 'DataRetrieverConstantsService'];
module.exports = ProfileChartToolbarController;